var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_wrapper",on:{"click":function($event){return _vm.onClick($event)}}},[_c('div',{staticClass:"btn--icon",class:{
      'ml-auto': _vm.isVertical,
      'mr-auto': _vm.isVertical,
      'mr-2': !_vm.isVertical
    }},[_c('div',{staticClass:"icon_wrapper"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"btn--text",class:{
      'text-center': _vm.isVertical,
      'd-block': _vm.isVertical,
      [`text-${_vm.color}`]: !!_vm.color
    }},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }